import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import './converge-list.scss';
import { ReactNode } from 'react';

interface IProps<T> {
  renderItem: (item: T) => ReactNode;
  items: T[];
}

export const ConvergeList = <T,>({ items, renderItem }: IProps<T>) => {
  return (
    <div className="converge-list">
      <List className="list-container">
        {items.map((item, index) => (
          <ConvergeListItem key={index} item={item} renderItem={renderItem} />
        ))}
      </List>
    </div>
  );
};

interface IConvergeListItemProps<T> {
  renderItem: (item: T) => ReactNode;
  item: T;
}

const ConvergeListItem = <T,>({
  item,
  renderItem,
}: IConvergeListItemProps<T>) => {
  return (
    <>
      <ListItem>
        <ListItemText primary={renderItem(item)} />
      </ListItem>
      <Divider variant="inset" component="li" />
    </>
  );
};
